// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + "2a08bdbf303555f8ee28" + ".css";
};